import { Logger } from "../../tools/Logger";
import { Connection } from "./aircraftSlice";
import { Sim } from "./types";
import { UavConnection } from "./UavConnection";

export class Websockets {
  private TAG: string = "Websockets";
  private uavConnections: UavConnection[] = [];
  private static instance: Websockets;
  public addUavConnection = (
    sims: Sim[],
    token: string,
    uavId: string,
    port: string
  ) => {
    Logger.info(
      this.TAG,
      `addUavConnection ${uavId} ${sims.map((sim) => sim.ip).join(", ")} `
    );

    if (
      !this.uavConnections.find(
        (uavConnection) => uavConnection.getUavId() === uavId
      )
    ) {
      this.uavConnections = [
        ...this.uavConnections,
        new UavConnection(sims, token, uavId, port),
      ];
    } else {
      this.uavConnections = this.uavConnections = [
        ...this.uavConnections,
        new UavConnection(sims, token, uavId, port),
      ];
    }
  };

  private getUavConnectionById = (uavId: string) => {
    return this.uavConnections.find(
      (uavConnection) => uavConnection.getUavId() === uavId
    );
  };
  public send = (uavId: string, data: any) => {
    return this.uavConnections
      .find((uavConnection) => uavConnection.getUavId() === uavId)
      ?.send(data);
  };
  public restartUavConnections = (connections: Connection[]) => {
    Logger.info(
      this.TAG,
      `restartUavConnections ${connections?.length} connections: ${connections
        ?.map((connection) => connection.uavId)
        .join(",")}`
    );
    connections.forEach((connection) =>
      this.addUavConnection(
        connection.sims,
        connection.tokenString,
        connection.uavId,
        connection.port || ""
      )
    );
  };
  public disconnectUav = (uavId: string) => {
    Logger.info(this.TAG, `disconnectUav ${uavId}`);

    let connToKill: UavConnection | null | undefined = this.uavConnections.find(
      (uavConnection) => {
        if (uavConnection.getUavId() === uavId) {
          Logger.info(this.TAG, `uav found, destroying ${uavId}`);
          uavConnection?.destroyConnection();
          return true;
        } else {
          Logger.error(this.TAG, `uav not found, not destroying ${uavId}`);
        }
      }
    );
    this.uavConnections = this.uavConnections.filter(
      (uavConnection) => uavConnection.getUavId() !== uavId
    );
    connToKill = null;
  };

  public disconnectAllUavs = () => {
    Logger.info(this.TAG, `Killing all drone connections`);
    this.uavConnections.forEach((uavConn) => {
      try {
        uavConn.destroyConnection();
      } catch (err) {
        Logger.error(
          this.TAG,
          `Killing ${uavConn.getUavId()} connection failed`
        );
      }
    });
  };

  public static getInstance(): Websockets {
    if (!Websockets.instance) {
      Websockets.instance = new Websockets();
    }

    return Websockets.instance;
  }
}
